import React from 'react'
import PropTypes from 'prop-types'
import Input from 'components/common/input/Input'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { CloudArrowUp, PaperPlaneRight, X } from 'phosphor-react'

function GalleryUploadPanel({
  inputValue,
  onInputChange,
  onAttachLink,
  getRootProps,
  getInputProps,
  loading,
  uploadProgress,
  items,
  onRemoveItem,
}) {
  return (
    <div className='event-create-card event-gallery-card'>
      <div className='event-about-content-panel'>
        <div className='event-about-content-panel__label'>Enter link</div>
        <div className='event-about-content-panel__input-row'>
          <div className='event-about-content-panel__input-wrap'>
            <Input
              name='galleryInput'
              value={inputValue}
              handleChange={onInputChange}
              placeholder='http://'
              label=''
            />
            <button
              type='button'
              className='event-about-content-panel__send-btn'
              onClick={onAttachLink}
              aria-label='Attach gallery link'
            >
              <PaperPlaneRight size={20} weight='regular' />
            </button>
          </div>
        </div>

        {items?.length ? (
          <div className='event-about-content-tags'>
            {items.map((file) => {
              const fileUrl = file.imageUrl || file.vidUrl || file.link || ''
              const label = file.name || fileUrl
              return (
                <div key={fileUrl} className='event-about-content-tag'>
                  <span>{label}</span>
                  <button
                    type='button'
                    onClick={() => onRemoveItem(file)}
                    aria-label='Remove gallery item'
                  >
                    x
                  </button>
                </div>
              )
            })}
          </div>
        ) : null}

        <div className='event-about-content-divider'>
          <div className='event-about-content-divider__line' />
          <span>OR</span>
          <div className='event-about-content-divider__line' />
        </div>

        {loading ? (
          <div className='event-about-content-upload event-about-content-upload--loading'>
            <p>Please wait for the File to upload!</p>
            <ProgressBar
              className='event-upload-progress'
              now={uploadProgress}
              label={`${uploadProgress}%`}
            />
          </div>
        ) : (
          <div {...getRootProps()} className='event-about-content-upload'>
            <input {...getInputProps()} />
            <CloudArrowUp size={24} />
            <p>Choose a file or drag &amp; drop it here.</p>
            <span>JPEG, PNG, PDF, and MP4 formats, up to 50 MB.</span>
            <button type='button' className='event-about-content-upload__browse'>
              Browse File
            </button>
          </div>
        )}

        {loading ? (
          <div className='event-gallery-file-card'>
            <div className='event-gallery-file-card__top'>
              <div className='event-gallery-file-card__meta'>
                <p>Uploading file...</p>
                <small>{`${uploadProgress}% complete`}</small>
              </div>
              <button type='button' className='event-gallery-file-card__close' disabled>
                <X size={16} />
              </button>
            </div>
            <ProgressBar now={uploadProgress} className='event-gallery-file-card__progress' />
          </div>
        ) : null}
      </div>
    </div>
  )
}

GalleryUploadPanel.propTypes = {
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  onAttachLink: PropTypes.func.isRequired,
  getRootProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  uploadProgress: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onRemoveItem: PropTypes.func.isRequired,
}

GalleryUploadPanel.defaultProps = {
  inputValue: '',
  items: [],
}

export default GalleryUploadPanel
